module.exports = __webpack_public_path__ + "static/media/spribe.9499949c.webp";